import React, { useEffect } from 'react'
import { useState } from 'react'
import { useHistory } from "react-router-dom";

import PrivacyPolicy from '../../components/media/privacy-policy.component'
import PrivacyPolicyHR from '../../components/media/privacy-policy-hr.component'
import loadNIASScript from '../../utils/load-nias-script';
import backimg from "../../images/back-button.png"

import './privacy.style.scss'
function PrivacyPage() {
  const [lang, setLang] = useState('EN')
  let history = useHistory();

  useEffect(() => {
    loadNIASScript(null, null)
  },[])

  return (
    <div className="privacy-container">
      <div className='privacy-button-container'>
        <img className="privacy-back-button" onClick={history.goBack} src={backimg} alt="Back" />
      </div>
      <div className="privacy-button-container">
        <span className={`privacy-lang-button ${lang === 'EN' ? 'active' : ''}`} onClick={() => setLang('EN')}>EN</span>
        <span className={`privacy-lang-button ${lang === 'HR' ? 'active' : ''}`} onClick={() => setLang('HR')}>HR</span>
      </div>
    
      {lang === 'HR' ? <PrivacyPolicyHR />: <PrivacyPolicy />}
    </div>
  )
}

export default PrivacyPage